import React from 'react';
import { Outlet } from 'react-router-dom';

import { Box, Container, Grid } from '@mui/material';
import { Header, Menu } from 'components';
import {
  DeclaracaoSaudeProvider,
  PrivateLayoutProvider,
  KeycloakProvider,
} from 'context';
import { keycloak } from 'services';

const PrivateLayout: React.FC = () => (
  <KeycloakProvider>
    <PrivateLayoutProvider>
      <Box sx={{ width: '100vw' }}>
        <Header />
        <Menu />

        <Grid
          container
          sx={{ width: '100%', height: '100%' }}
          justifyContent="center"
        >
          <Grid item lg={10} md={9} sm={12}>
            <Box sx={{ mt: 10 }}>
              <Container maxWidth="lg">
                <DeclaracaoSaudeProvider>
                  <Outlet />
                </DeclaracaoSaudeProvider>
              </Container>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </PrivateLayoutProvider>
  </KeycloakProvider>
);

export default PrivateLayout;
